<template>
  <div>
    <div>
      <router-link to="/">Home</router-link>
      <label class="labelBar"> / </label>
      <label> Cadastro/Equipamento/Proprietários</label>
    </div>
    <tab-navegacao-equipamento />
    <v-container fluid
      ><v-row align="center">
        <v-col>
          <v-btn
            v-if="isAllowed(7)"
            color="info"
            to="/proprietario/criar"
            class="ma-2 white--text"
          >
            NOVO
          </v-btn>
        </v-col>
        <v-col class="text-right">
          <v-checkbox
            v-if="proprietarios.length > 0"
            v-model="showAtivo"
            label="MOSTRAR ITENS INATIVOS"
          ></v-checkbox>
        </v-col>
        <v-col class="text-right">
          <v-btn
            @click="baixarlista()"
            v-if="proprietarios.length > 0"
            class="ma-2 blue--text"
            align="right"
          >
            <v-icon>mdi-file-excel</v-icon>
            Baixar planilha
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
    <v-card>
      <v-card-title>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Pesquisar"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="filteredList"
        class="elevation-1"
        :loading="loading"
        loading-text="Buscando dados..."
        :search="search"
        :footer-props="{
          showFirstLastPage: true,
          itemsPerPageText: 'Items por página',
          itemsPerPageOptions: [5, 10, 15, -1],
        }"
      >
        <template v-slot:item.ativo="{ item }">
          {{ item.ativo ? "Ativo" : "Inativo" }}
        </template>
        <template v-slot:item.actions="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                color="primary"
                class="mr-2"
                @click="editar(item)"
                v-bind="attrs"
                v-on="on"
              >
                mdi-pencil
              </v-icon>
            </template>
            <span v-if="isAllowed(3)">Editar</span>
            <span v-else>Ver</span>
          </v-tooltip>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { getUserRoles } from "@/services/loginService";
import { downloadLista } from "@/services/proprietarioService";

export default {
  name: "listaequipamentos",
  data() {
    return {
      loading: false,
      search: "",
      showAtivo: false,
      headers: [
        {
          text: "Id",
          align: "start",
          value: "id",
        },
        { text: "Proprietário", value: "nome" },
        { text: "CNPJ", value: "cnpj" },
        { text: "Status", value: "ativo" },
        { text: "", value: "actions", sortable: false },
      ],
    };
  },
  computed: {
    ...mapState("equipamento", ["proprietarios"]),
    filteredList() {
      if (this.showAtivo === false) {
        return this.proprietarios.filter((f) => {
          return f.ativo === true;
        }).sort( function ( a, b ) { return b.id - a.id; } );
      } else {
        return this.proprietarios.sort( function ( a, b ) { return b.id - a.id; } );
      }
    },
  },
  methods: {
    ...mapActions("equipamento", [
      "atualizarProprietarios",
      "atualizarProprietario",
    ]),
    baixarlista() {
      downloadLista();
    },
    editar(equipamento) {
      this.atualizarProprietario(equipamento);
      if (this.isAllowed(7)) {
        this.$router.push(`/proprietario/editar`);
      } else {
        this.$router.push(`/proprietario/ver`);
      }
    },
    async obterLista() {
      this.loading = true;
      await this.atualizarProprietarios();
      this.loading = false;
    },
    isAllowed(id) {
      var regra = this.regras.find((r) => {
        return r.idModulo == id;
      });
      return regra != null && regra.escrita;
    },
  },
  created: function () {
    this.obterLista();
    var roles = getUserRoles();
    if (roles) {
      this.regras = roles;
    }
  },
  components: {
    TabNavegacaoEquipamento: () =>
      import("@/components/Tabs/TabCadastroEquipamento"),
  },
};
</script>